globalThis.WorldDocument = class WorldDocument {
  constructor(data) {
    if (typeof data === "string") this.world = data;
    else if (typeof data === "object") Object.assign(this, data);
    if (!this.data) this.data = this.world || "AAA\nA A\nAAA";
    delete this.world;
  }

  getSize() {
    const rows = this.data.split("\n");
    const y = rows.length - 2;
    let x = 0;
    for (const row of rows) x = Math.max(x, row.length - 2);
    return new Vector2(x, y);
  }
};
